import { faPalette } from "@fortawesome/pro-solid-svg-icons"
import { Button, Divider, TextField } from "@mui/material"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { HexColorPicker } from "react-colorful"
import { connect } from "react-redux"
import { IColorPickerPopupState } from "ui/model"
import { closeColorPickerPopup } from "ui/tools/color-picker-popup"
import { isPhoneScreen } from "ui/tools/responsive"
import { FlexBox } from "./FlexBox"
import { Popup } from "./Popup"

interface IColorPickerPopupProps extends IColorPickerPopupState {
  isPhone: boolean
}

const ColorPickerPopupFn = React.memo(({ isOpened, title, hexColor, isPhone, setHexColor }: IColorPickerPopupProps) => {
  const [pickedColor, setPickedColor] = React.useState(hexColor.replace("!important", "").trim())
  const [inputColor, setInputColor] = React.useState(hexColor.replace("!important", "").trim())
  React.useEffect(() => {
    setPickedColor(hexColor.replace("!important", "").trim())
    setInputColor(hexColor.replace("!important", "").trim())
  }, [isOpened])
  if (!isOpened) {
    return null
  }
  const isColorValid = (color: string): boolean => /^#[0-9A-F]{6}$/i.test(color)
  const setColor = (newColor: string) => {
    if (isColorValid(newColor)) {
      setPickedColor(newColor)
    }
    if (newColor !== inputColor) {
      setInputColor(newColor)
    }
  }
  return (
    <Popup
      icon={faPalette}
      id="color-picker-popup"
      displayCloseIcon
      title={title}
      onClose={() => closeColorPickerPopup()}>
      <FlexBox vertical gap>
        <FlexBox gap vertical={isPhone}>
          <HexColorPicker color={pickedColor} onChange={newColor => setColor(newColor)} />
          <FlexBox vertical gap>
            <FlexBox
              sx={{
                width: "12.5rem",
                height: "8.2rem",
                backgroundColor: pickedColor,
                border: "1px solid black",
                borderRadius: ".25rem"
              }}
            />
            <TextField
              value={inputColor}
              onChange={event => setColor(event.target.value)}
              sx={{
                "width": "12.5rem",
                "& input": {
                  color: theme => (isColorValid(inputColor) ? theme.palette.text.primary : theme.palette.error.main)
                }
              }}
            />
          </FlexBox>
        </FlexBox>
        <Divider sx={{ width: "100%" }} />
        <FlexBox fullWidth gap jc="end">
          <Button variant="outlined" onClick={() => closeColorPickerPopup()}>
            {translate("button.cancel")}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (pickedColor !== hexColor) {
                setHexColor(pickedColor)
              }
              closeColorPickerPopup()
            }}>
            {translate("button.ok")}
          </Button>
        </FlexBox>
      </FlexBox>
    </Popup>
  )
})

export const ColorPickerPopup = connect(
  (state: IRootState): IColorPickerPopupProps => ({
    ...state.ui.colorPickerPopup,
    isPhone: isPhoneScreen(state)
  })
)(ColorPickerPopupFn)
